import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": _vm.cardTitle,
      "size": "small"
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm.$route.query.type != 2 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.saveDraft();
      }
    }
  }, [_vm._v(" 保存 ")]) : _vm._e(), _vm.$route.query.type != 2 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitNotice
    }
  }, [_vm._v(" " + _vm._s(_vm.showButtonName) + " ")]) : _vm._e()], 1), _c('a-form-model', {
    ref: "addForm",
    class: _vm.$route.query.type == 2 ? 'disabled-cursor' : '',
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.$route.query.type == 2 ? 'disabled-events' : ''
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告分类",
      "prop": "type"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择公告分类"
    },
    model: {
      value: _vm.formObject.type,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "type", $$v);
      },
      expression: "formObject.type"
    }
  }, _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateId
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告标题",
      "prop": "title"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公告标题",
      "max-length": 201
    },
    model: {
      value: _vm.formObject.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "title", $$v);
      },
      expression: "formObject.title"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "emergency", $$v);
      },
      expression: "formObject.emergency"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否置顶显示",
      "prop": "isTop"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.isTop,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isTop", $$v);
      },
      expression: "formObject.isTop"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "39px"
    },
    style: {
      width: '95.5%'
    },
    attrs: {
      "label": "公告摘要",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "digest"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公告摘要",
      "max-length": 101,
      "rows": 2
    },
    model: {
      value: _vm.formObject.digest,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "digest", $$v);
      },
      expression: "formObject.digest"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告排序",
      "prop": "sort"
    }
  }, [_c('a-input-number', {
    style: {
      width: '100%'
    },
    attrs: {
      "min": 1,
      "max": 9999,
      "placeholder": "请输入公告排序"
    },
    model: {
      value: _vm.formObject.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "sort", $$v);
      },
      expression: "formObject.sort"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId"
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObject.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObject.organPostId"
    }
  })], 1)], 1)], 1), _vm.isDirector ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需财务总监审核",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.isDirectorJWB ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需要加签",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "label": "发布范围",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 21
      },
      "prop": "range"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.range,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "range", $$v);
      },
      expression: "formObject.range"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0,
      "disabled": !_vm.allDisabled
    }
  }, [_vm._v(" 全校教职工 ")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("当前组织层级")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("当前组织层级指定人员")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("自定义")]), _vm.formObject.range === 1 || _vm.formObject.range === 3 ? _c('div', {
    staticStyle: {
      "height": "15px"
    }
  }) : _vm._e(), _vm.formObject.range === 1 ? _c('select-person', {
    ref: "selectPerson",
    attrs: {
      "businessId": _vm.businessId,
      "width": "100%",
      "height": "150px"
    },
    model: {
      value: _vm.formObject.customize,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "customize", $$v);
      },
      expression: "formObject.customize"
    }
  }) : _vm._e(), _vm.formObject.range === 3 ? _c('a-select', {
    style: {
      width: '100%'
    },
    attrs: {
      "allowClear": "",
      "show-search": "",
      "mode": "multiple",
      "placeholder": "请选择指定人员",
      "option-filter-prop": "children"
    },
    scopedSlots: _vm._u([{
      key: "dropdownRender",
      fn: function fn(menu) {
        return _c('div', {}, [_c('div', {
          staticClass: "dropdown-slot",
          on: {
            "mousedown": function mousedown(e) {
              return e.preventDefault();
            },
            "click": _vm.switchItem
          }
        }, [_c('div', {
          staticClass: "prompt"
        }, [_vm._v(" 已选择：" + _vm._s(_vm.selectOption || '未选择') + " ")]), _c('a-checkbox', {
          model: {
            value: _vm.optionAll,
            callback: function callback($$v) {
              _vm.optionAll = $$v;
            },
            expression: "optionAll"
          }
        }, [_vm._v("全选")])], 1), _c('v-nodes', {
          attrs: {
            "vnodes": menu
          }
        })], 1);
      }
    }], null, false, 592299145),
    model: {
      value: _vm.optionVal,
      callback: function callback($$v) {
        _vm.optionVal = $$v;
      },
      expression: "optionVal"
    }
  }, _vm._l(_vm.optionData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticClass: "form-wangedit",
    staticStyle: {
      "margin-left": "35px"
    },
    style: {
      width: '95.5%'
    },
    attrs: {
      "label": "公告内容",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "margin-top": "10px"
    }
  }, [_c('Toolbar', {
    staticStyle: {
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "editor": _vm.editor,
      "defaultConfig": _vm.toolbarConfig,
      "mode": _vm.mode
    }
  }), _c('Editor', {
    staticStyle: {
      "height": "400px",
      "overflow-y": "hidden"
    },
    attrs: {
      "defaultConfig": _vm.editorConfig,
      "mode": _vm.mode
    },
    on: {
      "onCreated": _vm.onCreated
    },
    model: {
      value: _vm.formObject.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "content", $$v);
      },
      expression: "formObject.content"
    }
  })], 1)])], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "35px",
      "pointer-events": "auto"
    },
    style: {
      width: '95.5%'
    },
    attrs: {
      "label": "文件",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_vm.$route.query.type == 2 ? _c('a-list', {
    attrs: {
      "data-source": _vm.formObject.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filePath),
            "download": item.fileName
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.fileName) + " ")])]), _c('div', [_vm._v(_vm._s(item.createTime))])], 1);
      }
    }], null, false, 3914301722)
  }) : _c('a-upload-dragger', {
    staticClass: "common-upload",
    attrs: {
      "name": "file",
      "accept": ".pdf,.doc,.docx,.jpg,.jpge,",
      "multiple": true,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "fileList": _vm.fileObj,
      "remove": _vm.delFile
    },
    model: {
      value: _vm.fileObj,
      callback: function callback($$v) {
        _vm.fileObj = $$v;
      },
      expression: "fileObj"
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1)], 1)], 1)], 1)])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };